import { useReducer } from 'react';
import { EventsStateContext, EventsDispatchContext } from './eventsContext';
import { eventsReducer } from './events.reducer';

/**
 * EventsProvider
 * @param {Object}    children    - Component on which the provider data will be available
 */
export function EventsProvider({
  children
}) {
  const [state, dispatchEvents] = useReducer(eventsReducer, {
    showToast: false
  });
  return <EventsStateContext.Provider value={state}>
      <EventsDispatchContext.Provider value={dispatchEvents}>
        {children}
      </EventsDispatchContext.Provider>
    </EventsStateContext.Provider>;
}